/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55967492
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { clone, concat, dropLast, find, isEmpty, isNil, keys, length, omit, propEq, type, values, uniq, equals } from 'ramda';
import Accordion from '@components/@core/Accordion';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import CareerCertificationHeader from '@components/CareerCertificationHeader';
import * as ProgramsList from '@components/LibraryProgramsList';
import * as Instances from '@components/CareerRequiredInstances';
import Dropdown from '@components/@core/Dropdown';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import Input from '@components/@core/Input';
import Pagination from '@components/@core/Pagination';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import StepBar from '@components/@core/StepBar';
import Settings from '@components/@core/Settings';
import TrainingCourses from '~/views/Manage/Reports/TrainingCourses';
import Toggle from '@components/@core/Toggle';
import { LibraryLevels, LibraryProgramDetailMenu, LibraryTypes } from '~/services/config';
import { getAvatarUrl } from '~/services/util';

const OPTIONS = [{ id: 1, value: 'Default from courses, Target for track' }];

class Edit extends Component {
    state = {
        authors: this.props.tags.authors,
        departments: this.props.tags.departments,
        competencies: this.props.tags.competencies,
        categories: this.props.tags.categories,
        thumbnail: this.props.program.data.thumb_url || null,
        job: find(propEq('id', this.props.program.job_role_id), this.props.jobs) || {},
        program: this.props.program,
        isLevel: false,
        levelData: [],
        canPublish: true,
        level: keys(this.props.program.data.levels).length,
        levelInd: 0,
        documents: this.props.program?.data?.documents,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { program } = prevState;
        const isLevel = !isNil(program.data.levels) && !isEmpty(program.data.levels);
        const levelData = isLevel ? values(program.data.levels) : [];

        let newLevelData = clone(levelData);
        let canPublish = true;
        let card = clone(nextProps.location?.state?.card) || {};
        newLevelData.forEach((item, index) => {
            const duplicate = item.quotas.some((item) => item.id === card.id);
            if (nextProps.location?.state?.level === index + 1 && !duplicate) item.quotas.push(card);
            item.quotas.forEach((quota) => {
                if (quota.quota_target === 0 || isNil(quota.quota_calculation)) canPublish = false;
            });
        });
        return { isLevel, levelData: newLevelData, canPublish };
    }

    handleTitle = (e) => {
        const { program } = this.state;
        this.setState({ program: { ...program, title: e } });
    };

    handleDescription = (e) => {
        const { program } = this.state;
        this.setState({
            program: { ...program, data: { ...program.data, description: e } },
        });
    };

    handleSelectTags = (key) => (tag) => {
        const { program } = this.state;
        switch (key) {
            case 'author':
                this.setState({ program: { ...program, author_id: tag[0] } });
                break;
            case 'department':
                this.setState({ program: { ...program, data: { ...program.data, department_id: tag } } });
                break;
            case 'competency':
                this.setState({ program: { ...program, data: { ...program.data, competency_id: tag } } });
                break;
            case 'category':
                this.setState({ program: { ...program, data: { ...program.data, category_id: tag } } });
                break;
            case 'role':
                this.setState({ program: { ...program, job_role_id: tag[0].id } });
                break;
            default:
                break;
        }
    };

    handleChangeLevel = (key, ind) => (e) => {
        const { isLevel, program } = this.state;
        if (!isLevel) return;
        let _levels = clone(program.data.levels);
        if (key == 'trainings') {
            _levels[ind][key] = { ..._levels[ind][key], items: e };
        } else if (key == 'documents') {
            this.setState({ documents: e });
            return;
        } else {
            _levels[ind][key] = e;
        }
        const _program = { ...program, data: { ...program.data, levels: _levels } };
        this.setState({ program: _program });
    };

    handleAddModule = (type, ind) => () => {
        const { program } = this.state;
        let _levels = clone(program.data.levels);
        let after = [];
        if (type === 'quotas') {
            after = _levels[ind][type];
        } else if (type === 'habits') {
            after = concat(concat(_levels[ind][type].day, _levels[ind][type].week), _levels[ind][type].month);
        } else if (type === 'tracks' || type === 'courses') {
            after = _levels[ind]['trainings'].items;
        }

        const handleAttach = (e) => {
            if (type === 'quotas') {
                _levels[ind]['quotas'] = concat(_levels[ind]['quotas'], e.templates);
            } else if (type === 'habits') {
                let day = [],
                    week = [],
                    month = [];
                e.templates.map((item) => {
                    if (item.data.schedule_interval === 'day') day.push(item);
                    else if (item.data.schedule_interval === 'week') week.push(item);
                    else month.push(item);
                });
                _levels[ind]['habits'].day = concat(_levels[ind]['habits'].day, day);
                _levels[ind]['habits'].week = concat(_levels[ind]['habits'].week, week);
                _levels[ind]['habits'].month = concat(_levels[ind]['habits'].month, month);
            } else if (type === 'tracks' || type === 'courses') {
                let templates = clone(e.templates);
                templates = templates.map((item) => {
                    item.type = dropLast(1, type);
                    return item;
                });
                _levels[ind]['trainings'].items = concat(_levels[ind]['trainings'].items, templates);
            }
            const _program = { ...program, data: { ...program.data, levels: _levels } };
            this.setState({ program: _program });
        };

        this.props.onModal({
            type: 'Attach Library',
            data: { before: { modules: [], show: [type], selected: [] }, after },
            callBack: {
                onAttach: (e) => handleAttach(e),
                onAdd: () => {
                    if (type === 'quotas') {
                        this.props.onModal({
                            type: 'Add New Quota',
                            data: { before: { quota: null } },
                            callBack: { onAttach: (e) => handleAttach(e) },
                        });
                    }
                },
            },
        });
    };

    handleSelectModule = (ind) => (e) => {
        const type = e[0].name;
        const modalType = e[0].type;
        const { program, documents } = this.state;
        let _levels = clone(program.data.levels);
        let after = _levels[ind]['trainings'].items;

        this.props.onModal({
            type: 'Attach Library',
            data: { before: { modules: [], show: [type], selected: [] }, after },
            callBack: {
                onAttach: (e) => {
                    if (modalType === 'training') {
                        let templates = clone(e.templates);
                        templates = templates.map((item) => {
                            item.type = dropLast(1, type);
                            return item;
                        });
                        _levels[ind]['trainings'].items = concat(_levels[ind]['trainings'].items, templates);
                        const _program = { ...program, data: { ...program.data, levels: _levels } };
                        this.setState({ program: _program });
                    } else {
                        let _documents = clone(e.templates);
                        _documents = uniq(concat(documents, _documents));
                        this.setState({ documents: _documents });
                    }
                },
            },
        });
    };

    handleContentPagination = (e) => {
        this.setState({ levelInd: e - 1 });
    };

    handleLevelDelete = (index) => () => {
        let { program, level } = this.state;
        let _levels = clone(program.data.levels);
        _levels = omit([index], _levels);
        _levels = values(_levels);
        level = _levels.length;
        let levels = {};
        for (let i = 0; i < level; i++) {
            levels[i + 1] = { ..._levels[i] };
        }
        const _program = { ...program, data: { ...program.data, levels } };
        this.setState({ program: _program, level, levelInd: 0 });
    };

    handleAddLevel = () => {
        let { program, level, levelInd } = this.state;
        let _levels = clone(program.data.levels);
        _levels[level + 1] = {
            title: `Level ${Object.values(program.data.levels)?.length + 1}`,
            time_lock: false,
            habits: { day: [], week: [], month: [] },
            quotas: [],
            trainings: { items: [] },
        };
        const _program = { ...program, data: { ...program.data, levels: _levels } };
        level = values(_levels).length;
        this.setState({ program: _program, level, levelInd: levelInd + 1 });
    };

    handleDrop = (e) => {
        this.setState({ thumbnail: e });
    };

    handleSubmit = (published) => () => {
        const { isLevel, program, thumbnail, documents } = this.state;
        const _levels = isLevel ? clone(program.data.levels) : null;
        const isImage = typeof thumbnail?.name == 'string';
        let levels = {};

        if (!isNil(_levels)) {
            keys(_levels).map((key) => {
                const day = _levels[key].habits.day.map((item) => item.id);
                const week = _levels[key].habits.week.map((item) => item.id);
                const month = _levels[key].habits.month.map((item) => item.id);
                const habits = { day, week, month };
                const quotas = _levels[key].quotas.map((item) => {
                    return {
                        quota_template_id: item.id,
                        quota_target: item.quota_target || 0,
                        quota_calculation: item.quota_calculation || 0,
                        span_months: item.span_months || 0,
                        quota_direction: item.quota_direction || 0,
                        minimum_months: item.minimum_months || 0,
                    };
                });
                const trainings = _levels[key].trainings.items.map((item) => ({
                    type: item.type,
                    item_id: item.id,
                }));
                levels[key] = {
                    ..._levels[key],
                    icon_url: thumbnail,
                    habits,
                    quotas,
                    trainings: { ..._levels[key].trainings, items: trainings },
                };
            });
        }
        const _program = { ...program, published, data: { ...program.data, levels, documents } };
        const payload = { type: 'careers', data: { program: _program } };
        this.props.onSave(payload, isImage ? thumbnail : null);
    };
    handleLabelTitle = (title) => {
        const { program, levelInd } = this.state;
        const _data = {
            ...program,
            data: {
                ...program.data,
                levels: {
                    ...program.data.levels,
                    [Number(levelInd) + 1]: {
                        ...program.data.levels[Number(levelInd) + 1],
                        title: title,
                    },
                },
            },
        };
        this.setState({ program: _data });
    };

    render() {
        const { canPublish, levelData, authors, departments, competencies, categories, program, level, levelInd, thumbnail, documents } = this.state;
        const { userRole, onSelect, jobs, quotaOptions } = this.props;
        const programLevels = Object.values(program.data.levels);

        const trainingTypes = [
            { id: 0, value: 'Add Course', name: 'courses', type: 'training' },
            { id: 1, value: 'Add Track', name: 'tracks', type: 'training' },
        ];
        const documentTypes = [
            { id: 0, value: 'Add Power Point', name: 'powerpoint', type: 'documents' },
            { id: 1, value: 'Add Word', name: 'word', type: 'documents' },
            { id: 3, value: 'Add PDF', name: 'pdf', type: 'documents' },
        ];

        const { habits, quotas, trainings, title } = levelData[levelInd];
        const habitsLength = type(habits) === 'Object' ? length(habits.day) + length(habits.week) + length(habits.month) : length(habits);

        const disabled = equals(this.props.program, program) || !canPublish;

        const expirations = [
            { id: 0, name: 'Never' },
            { id: 1, name: '6 months' },
            { id: 2, name: '12 months' },
            { id: 3, name: '24 months' },
            { id: 4, name: '36 months' },
        ];

        const settings = [
            { name: 'Author', id: [program.author_id], options: authors, select: 'author' },
            {
                name: 'Departments',
                id: program.data.department?.length > 0 ? program.data.department : null,
                options: departments,
                select: 'department',
            },
            {
                name: 'Competencies',
                id: program.data.competency?.length > 0 ? program.data.competency : null,
                options: competencies,
                select: 'competency',
            },
            {
                name: 'Categories',
                id: program.data.category?.length > 0 ? program.data.category : null,
                options: categories,
                select: 'category',
            },
        ];
        return (
            <div className="lib-programs-career">
                <div>
                    <CareerCertificationHeader program={this.state.program} type="careers" changeTitle={this.handleTitle} changeDescription={this.handleDescription} editable />
                </div>
                <div className="modules-contents mt-3">
                    <div key={`level-${levelInd}`}>
                        <div className="d-flex">
                            <p className="d-flex-1 dsl-b22 bold">Requirements</p>
                        </div>
                        <ResponsiveTabs
                            className="mb-3"
                            active={`${levelInd}`}
                            data={programLevels?.map((level, index) => ({
                                id: `${index}`,
                                name: level?.title?.length > 15 ? `${level.title?.substring(0, 15)}...` : level?.title || 'NA',
                            }))}
                            onTab={(e) => this.setState({ levelInd: Number(e.id) })}
                        />
                        <div className="d-flex">
                            <Input title="Level Title" value={programLevels[levelInd].title} onChange={this.handleLabelTitle} />
                        </div>
                        <div className="required-field pt-4">
                            <p className="dsl-b18 text-500">Goals</p>
                            <ProgramsList.QuotaList modules={quotas} quotaOptions={quotaOptions} onChange={this.handleChangeLevel('quotas', levelInd + 1)} type="career" />
                            <div className="d-h-end pt-4">
                                <Button name="Attach Goal" type="low" onClick={this.handleAddModule('quotas', levelInd + 1)} />
                            </div>
                        </div>
                        <div className="required-field">
                            <TrainingCourses data={trainings?.items} isEditable onChange={this.handleChangeLevel('trainings', levelInd + 1)} />
                            <div className="d-h-end py-4">
                                <Dropdown
                                    align="right"
                                    width="fit-content"
                                    caret="none"
                                    returnBy="data"
                                    placeholder="Attach Learning"
                                    className="add-training-dropdown"
                                    selectable={false}
                                    data={trainingTypes}
                                    onChange={this.handleSelectModule(Number(levelInd) + 1)}
                                />
                            </div>
                        </div>
                        <div className="py-4">
                            <p className="dsl-b18 text-500">Expiration</p>
                            <Dropdown className="expiration-dropdown" align="right" title="Expires:" data={expirations} getValue={(e) => e.name} />
                        </div>
                    </div>
                </div>

                <div className="mt-3 d-h-end">
                    <Button name="Add Level" type="low" onClick={this.handleAddLevel} />
                </div>
                <Settings values={settings} isEditable expanded handleSelect={this.handleSelectTags} />
                <div className="d-flex flex-column pt-3">
                    <div className="d-h-end mt-2">
                        <>
                            <Button className="btn-save me-3" name="Draft" disabled={disabled && !program.published} type="low" onClick={this.handleSubmit(0)} />
                            <Button className="btn-save" name="Publish" disabled={disabled && program.published} onClick={this.handleSubmit(1)} />
                        </>
                    </div>
                </div>
            </div>
        );
    }
}

Edit.propTypes = {
    jobs: PropTypes.array,
    userRole: PropTypes.number,
    tags: PropTypes.shape({
        authors: PropTypes.array,
        departments: PropTypes.array,
        competencies: PropTypes.array,
        categories: PropTypes.array,
    }),
    program: PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        data: PropTypes.any,
    }),
    location: PropTypes.object,
    navigate: PropTypes.func,
    onModal: PropTypes.func,
    onSave: PropTypes.func,
    onSelect: PropTypes.func,
};

Edit.defaultProps = {
    jobs: [],
    userRole: 1,
    tags: { authors: [], departments: [], competencies: [], categories: [] },
    program: { id: 0, title: '', data: {} },
    location: {},
    navigate: () => {},
    onModal: () => {},
    onSave: () => {},
    onSelect: () => {},
};

export default Edit;
